import { Routes, Route } from "react-router-dom";
import Header from "./components/Header/Header";
import Home from "./components/Home/Home";
import Team from "./components/Team/team";
import Portfolio from "./components/Portfolio/Portfolio";
import Services from "./components/About/Services";
import ContactPage from "./components/Contact/ContactPage";
import Footer from "./components/Footer/Footer";
import Blog from "./components/Blog/Blog";
import SingleBlog from "./components/Blog/SingleBlog";
import PortfolioDetails from "./components/Portfolio/PortfolioDetails";
import ComingSoon from "./components/ComingSoon/ComingSoon";
import Video from "./components/Video/Video";
import VideoDetails from "./components/Video/VideoDetails";

function App() {
  const isLive = false; // 🔥 change to true when site is ready

  // 🚫 SITE LOCKED
  if (!isLive) {
    return <ComingSoon />;
  }

  // ✅ SITE LIVE
  return (
    <>
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<Services />} />
        <Route path="/team" element={<Team />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/portfolio/:id" element={<PortfolioDetails />} />
        <Route path="/video" element={<Video />} />
        <Route path="/video/:id" element={<VideoDetails />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<SingleBlog />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;
